import { captureDatadogRumAction } from "../../../telemetry/datadog-rum";
import {
  replayDiagnosticText,
  parseReplayDiagnostics,
} from "./replay-diagnostics";
import {
  durationMs,
  type ReplayIdentity,
  type ReplayTiming,
} from "./replay-timing";
import type { ViewerMessage } from "./replay-messages";

export function captureReplayFailure({
  data,
  viewerReady,
  timing,
  coworldId,
  telemetryContext,
  surface,
}: ReplayIdentity &
  Readonly<{
    data: ViewerMessage;
    viewerReady: boolean;
    timing: Readonly<ReplayTiming>;
  }>): string {
  const message = replayDiagnosticText({ value: data.message, limit: 1024 });
  captureDatadogRumAction({
    name: "coworld_replay_runtime_failure",
    context: {
      ...parseReplayDiagnostics(data.diagnostics),
      message,
      viewer_ready: viewerReady,
      failure_elapsed_ms: durationMs({
        start: timing.requestStartedAt,
        end: performance.now(),
      }),
      page_visible_at_end: document.visibilityState === "visible",
      viewer_manifest_hash: timing.viewerManifestHash,
      replay_delivery: timing.delivery,
      game: telemetryContext.game,
      game_version: telemetryContext.gameVersion,
      coworld_id: coworldId,
      episode_id: telemetryContext.episodeId,
      surface,
      frontend_version: process.env.NEXT_PUBLIC_GIT_COMMIT,
    },
  });
  return `Replay viewer failed: ${message || "could not load the replay"}`;
}
